import type { StateCreator } from "zustand";

import {
  getValueFromLocalStorage,
  setValueToLocalStorage,
} from "~/core/generic/storage-utils";

import { PIPELINE_SETTINGS_STORAGE_KEYS } from "../constants/common";
import type { ZPipelineSettingsState } from "../types/zustand";

export const pipelineSettingsSlice: StateCreator<ZPipelineSettingsState> = (
  set,
  get,
) => ({
  activePipelineId: null,
  setActivePipelineId: activePipelineId => {
    set({ activePipelineId });
  },

  pipelines: [],
  setPipelines: pipelines => {
    set({ pipelines });
  },

  isOpenCreatePipelineModal: false,
  setIsOpenCreatePipelineModal: isOpen => {
    const states: Partial<ZPipelineSettingsState> = {
      isOpenCreatePipelineModal: isOpen,
      pipelineTemplateId: null,
    };

    set(states);
  },

  pipelineTemplateId: null,
  setPipelineTemplateId: templateId => {
    set({ pipelineTemplateId: templateId });
  },

  showTips:
    getValueFromLocalStorage(PIPELINE_SETTINGS_STORAGE_KEYS.TIPS) ?? true,
  setShowTips: showTips => {
    setValueToLocalStorage(
      PIPELINE_SETTINGS_STORAGE_KEYS.TIPS,
      String(showTips),
    );
    set({ showTips });
  },

  newlyAddedStageId: null,
  setNewlyAddedStageId: stageId => {
    set({ newlyAddedStageId: stageId });
  },

  selectedStageIds: [],
  setSelectedStageIds: selectedStageIds => {
    set({ selectedStageIds });
  },
});
